<template>
  <base-switch
    :value="value !== topLabel"
    variant="vertical-toggle"
    class="vertical-toggle"
    @click="selectOption"
    @mouseenter.native="isHovered = true"
    @mouseleave.native="isHovered = false"
  >
    <template #default>
      {{ topLabel === value ? topLabel : bottomLabel }}
    </template>

    <template #checked>
      <div class="flex h-full w-full items-center justify-center rounded-md font-semibold uppercase text-2xs"
           :class="{ 'bg-gray-a10': isHovered }"
      >
        {{ topLabel }}
      </div>
    </template>

    <template #unchecked>
      <div :class="{ 'bg-gray-a10': isHovered }"
           class="flex h-full w-full items-center justify-center rounded-md font-semibold uppercase text-2xs"
      >
        {{ bottomLabel }}
      </div>
    </template>
  </base-switch>
</template>

<script>
import BaseSwitch from '@/components/base-components/BaseSwitch.vue'
import Template from '@/components/templates/Template.vue'

export default {
  name: 'VerticalSwitch',
  components: { Template, BaseSwitch },

  props: {
    topLabel: {
      type: String,
      required: true
    },
    bottomLabel: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isHovered: false
    }
  },

  methods: {
    async selectOption() {
      const newValue = this.value === this.topLabel ? this.bottomLabel : this.topLabel
      this.$emit('input', newValue)
    }
  }
}
</script>

